
import React from 'react'
import styles from './Header.module.css'
import Navbar from '../Navbar/Navbar'
import HeroSlider from '../slider/HeroSlider'



const Header = ({scrollToFooter}) => {
  return (
    <div className={styles.mainContainer}>
      <Navbar scrollToFooter = {scrollToFooter} />
      {/* <HeroSlider /> */}
      </div>


   
  )
}

export default Header
